import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material';
import { FileUploadComponent } from '../file-upload/file-upload.component';

import { Http, Response } from '@angular/http';

@Component({
  selector: 'app-cadastrar-paisagem',
  templateUrl: './cadastrar-paisagem.component.html',
  styleUrls: ['./cadastrar-paisagem.component.scss']
})
export class CadastrarPaisagemComponent implements OnInit {

  localization: any;
  name: any;
  text: any;
  fonts: any[] = [];
  image: any;
  font: any;
  imgURL: any;

  constructor( private toastr: ToastrService, public dialog: MatDialog, private http: Http) { }

  ngOnInit() {
  }

  addFont() {
    if (this.font) {
      this.fonts.push(this.font);
      this.font = null;
    }
  }

  removeFont(i) {
    this.fonts.splice(i, 1);
  }

  isOk(d) {
    if (!d) { return false; }
    const x = d.toString();
    if (!x || x.trim().length === 0 || x.trim() === '') {
      return false;
    }
    return true;
  }

  upload() {
    // console.log('aa', x);
    const dialogRef = this.dialog.open(FileUploadComponent, {
      width: '800px',
      // height: '75%',
      maxHeight: '80vh',
      data: {}
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.image = res;
        console.log(res);
      }
    });
  }


  send() {
    if (!this.isOk(this.localization)) {
      this.toastr.error('Informe a localização.');
      return;
    }
    if (!this.isOk(this.name)) {
      this.toastr.error('Informe o nome da paisagem.');
      return;
    }
    if (!this.isOk(this.text)) {
      this.toastr.error('Informe o texto descritivo.');
      return;
    }
    if (!this.fonts || !this.fonts.length) {
      this.toastr.error('Você deve informar pelo menos uma fonte.');
      return;
    }
    if (!this.image) {
      this.toastr.error('Você deve informar a imagem oficial da paisagem.');
      return;
    }

    const formData = new FormData();
    formData.append('image', this.image, this.image.name);
    formData.append('localization', this.localization);
    formData.append('name', this.name);
    formData.append('text', this.text);
    formData.append('createdBy', localStorage['token']);
    formData.append('fonts', JSON.stringify(this.fonts));
    this.http.post('https://us-central1-wiki-photos.cloudfunctions.net/api/paisagem/', formData).subscribe((val) => {
      if (val && val.status === 200) {
        this.toastr.success('Paisagem cadastrada');
      }  else {
        this.toastr.error('Ocorreu um erro, tente novamente.');
      }
      console.log(val);
    });
  }

  handleFileInput(files: FileList) {
    this.image = files.item(0);

    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
      // console.log(this.imgURL);
    };
  }

}
